// extracted by mini-css-extract-plugin
export default {"nav":"navHeader_nav__YNAFY","navImage":"navHeader_navImage__OY5Oz","userName":"navHeader_userName__bnBNC","menuButton":"navHeader_menuButton__pSTAw"};